import * as React from 'react'

function SvgHome(props, svgRef) {
  return (
    <svg viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M21.797 9.024L12.024.392a1.526 1.526 0 00-2.044 0L.203 9.024a.61.61 0 00-.046.863l.817.91a.61.61 0 00.863.045l.608-.535v8.636c0 .336.275.611.61.611h4.89a.613.613 0 00.61-.611v-4.889c0-.336.276-.61.612-.61h3.666c.336 0 .611.274.611.61v4.889c0 .336.275.611.611.611h4.89a.613.613 0 00.61-.611v-8.636l.608.535a.61.61 0 00.863-.046l.817-.909a.61.61 0 00-.046-.863z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgHome)
export default ForwardRef
